import { useNavigate, useParams } from 'react-router-dom';
import articlesData from '../articles/index.json';
import { Container, Box, useTheme, Typography } from '@mui/material';

import { FaqAccordionItem } from '../../../components/FaqAccordionItem/FaqAccordionItem';
import { GlassColors } from '../../../components/glassmorphism/GlassmorphismStyles';
const articles = articlesData.articles;

export const HelpBlogArticle: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const article = articles.find((a) => a.slug === slug);
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (!article) {
    navigate('/help-blog');
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: isDark ? '#1A1A1A' : '#E5E5DC',
        paddingTop: { xs: '80px', sm: '120px' },
        paddingBottom: { xs: '24px', sm: '48px' },
      }}
    >
      <Container
        maxWidth='lg'
        sx={{
          width: '956px',
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            maxWidth: '760px',
            margin: 'auto',
          }}
        >
          <Typography
            variant='h4'
            component='h1'
            sx={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: { xs: 700, sm: 500 },
              fontSize: { xs: '24px', sm: '34px', tablet: '60px' },
              color: isDark ? '#00FFFF' : '#005CAD',
              lineHeight: { xs: '133%', sm: '120%' },
              letterSpacing: { xs: 0, sm: '-.5px' },
              marginBottom: { xs: '16px', sm: '24px' },
              marginTop: { xs: '16px', sm: '16px' },
              textAlign: 'center',
            }}
          >
            {article?.title}
          </Typography>
          <Typography
            sx={{
              fontFamily: {
                xs: 'montserrat, sans-serif',
                sm: 'roboto, sans-serif',
              },
              fontSize: { xs: '12px', sm: '16px' },
              lineHeight: { xs: '166%', sm: '150%' },
              letterSpacing: { xs: '.4px', sm: '.15px' },
              fontWeight: { xs: 500, sm: 700 },
              color: isDark ? '#B6B6B6' : '#1A1A1A',
              textAlign: 'center',
              mb: '24px',
            }}
          >
            {article?.subtitle}
          </Typography>
        </Box>
        {article && (
          <Box
            sx={{
              maxWidth: '760px',
              margin: 'auto',
              fontFamily: 'roboto, sans-serif',
              fontSize: { xs: '14px', sm: '16px' },
              lineHeight: { xs: '143%', sm: '150%' },
              letterSpacing: { xs: '.17px', sm: '.15px' },
              color: isDark
                ? GlassColors.dark.textPrimary
                : GlassColors.light.textPrimary,
              mb: { xs: '24px', sm: '48px' },
              '& h3, & h4': {
                fontSize: { xs: '14px', sm: '16px' },
                fontWeight: 400,
                m: 0,
              },
              '& ul, & ol': {
                pl: '17px',
                m: 0,
              },
              '& strong': {
                fontWeight: 400,
              },
              '& p': {
                mt: 0,
              },
              '& p:has(+ ul), & p:has(+ ol)': {
                mb: 0,
              },
              'p:last-child': { mb: 0 },
              '& ul ul': {
                listStyle: 'disc',
              },
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: article?.html }} />
          </Box>
        )}

        {/* Q&A section start */}
        {article?.qa && (
          <Box>
            {article?.qa?.map((item, index) => (
              <FaqAccordionItem
                key={index}
                question={item.question}
                answer={item.answer}
                isDark={isDark}
              />
            ))}
          </Box>
        )}
      </Container>
    </Box>
  );
};
